import axios from 'axios';
import { getConfig } from '../../config/apiConfig';

const getUserTheme = async (themeKey) => {
  // Get auth header config
  const config = await getConfig();
  const url = 'api/rcore/usertheme';
  if (themeKey != null) {
    const reqObject = { OverrideTheme: true, ThemeKey: themeKey };
    config.params = reqObject;
  }
  return axios
    .get(url, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      throw err.response;
    });
};

export default getUserTheme;
